import type { IChatItem, ISolutionWithInnovation, ISuggestList } from '@/types';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

export const CoreInnovationApiService = Symbol('CoreInnovationApiService');

export interface CoreInnovationApiService {
    addPatent(project_id: string, patent_id: string): Promise<ISolutionWithInnovation>;
    removePatent(project_id: string, patent_id: string): Promise<boolean>;
    getSuggestList(data: string): Promise<ISuggestList[]>;
}

interface ISuggestListResponse {
    records: ISuggestList[]
}

@injectable()
export class CoreInnovationApiServiceImpl extends PsHttpService implements CoreInnovationApiService {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    addPatent(project_id: string, patent_id: string) {
        return this.post<PatSnapCommonResponseData<ISolutionWithInnovation>>({
            url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/add_key_patent`,
            data: {
                project_id,
                patent_id,
            },
        }).then((res) => {
            return res.data as ISolutionWithInnovation
        })
    }

    removePatent(project_id: string, patent_id: string) {
        return this.delete<PatSnapCommonResponseData<boolean>>({
            url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/${project_id}/key_patent/${patent_id}`,
        }).then((res) => {
            return res.data as boolean
        })
    }

    getSuggestList(data: string) {
        return this.post<PatSnapCommonResponseData<ISuggestListResponse>>({
            url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/patent/query/withPn`,
            data: {
                query: data,
                limit: 10,
            },
        }).then((res) => {
            const data = res.data as ISuggestListResponse
            return data.records
        })
    }
}
